import React from "react";
import { Select } from "antd";
import { MONUMENT } from "./monumentConstants";

function TicketInfoTable({
  orientation = "vertical",
  price,
  date,
  numberOfTickets,
  setNumberOfTickets,
  showSelect = false,
}) {
  const cellStyle = { width: 100, textAlign: "center" };

  return orientation === "horizontal" ? (
    <table>
      <thead>
        <th width={100}>DATA</th>
        <th width={100}>BILHETES</th>
        <th width={100}>PREÇO</th>
      </thead>
      <tbody>
        <tr>
          <td style={cellStyle}>{date}</td>
          <td style={cellStyle}>
            {showSelect ? (
              <Select
                options={MONUMENT.numberOfTicketsOptions}
                value={numberOfTickets}
                onSelect={setNumberOfTickets}
                bordered={false}
              />
            ) : (
              numberOfTickets
            )}
          </td>
          <td style={cellStyle}>{price} €</td>
        </tr>
      </tbody>
    </table>
  ) : (
    <>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">DATA</div>
        <div className="ahp-reservation-value">{date}</div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">BILHETES</div>
        <div className="ahp-reservation-value">
          {" "}
          {showSelect ? (
            <Select
              options={MONUMENT.numberOfTicketsOptions}
              value={numberOfTickets}
              onSelect={setNumberOfTickets}
              bordered={false}
            />
          ) : (
            numberOfTickets
          )}
        </div>
      </div>
      <div className="ahp-reservation-row">
        <div className="ahp-reservation-label">PREÇO</div>
        <div className="ahp-reservation-value">{price} €</div>
      </div>
    </>
  );
}

export default TicketInfoTable;
